(function () {
	'use strict';

	angular.module('app.supplyChain')
		.controller('excessToSell', excessToSell);

	excessToSell.$inject = ['$scope', '$rootScope', '$timeout', '$state', '$location', 'redirectParamsService', 'leanFilterService',
		'tableRenderService', 'tableService', 'currencyFormatService', 'storeService', 'crossSiteService'];

	function excessToSell($scope, $rootScope, $timeout, $state, $location, redirectParamsService, leanFilterService,
			tableRenderService, tableService, currencyFormatService, storeService, crossSiteService) {

		var vm = this;
		var unsubscribe;

		var reportSettingsName = 'excess-to-sell';
		var extraParams = [{
			excelReportName: 'CrossSiteExcess/Customer/' + globalConfig.customer.id
		}];
		var defaultFilters = [];

		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		var columns;
		var allFactoriesList;
		initDefaultColumns();

		var pageUrl = '{0}/CrossSiteExcess/Customer/' + globalConfig.customer.id;
		var rendererParams = {
			siteIDs: {},
			siteNames: {},
			'itemType': 'Purchased',
			'specificTaskType': 'task'
		};

		vm.showExcel = true;
		vm.exportToExcel = exportToExcel;

		$scope.filterService = leanFilterService;
		init();

		function init() {
			leanFilterService.clearFilters();
			leanFilterService.useFactoryFilter = true;
			defaultFilters = [{
				'id': 'factory',
				'values': [globalConfig.factory.id],
				'isMandatory': true
			}];
			var siteFilter = $scope.filterService.filterDefinitions['Factory'];
			siteFilter.type = 'singleSelect';
			siteFilter.displayName = 'Sell From';
			siteFilter.removable = false;
			$scope.filterService.setMasterFilterList([
				$scope.filterService.filterDefinitions['Supplier'],
				$scope.filterService.filterDefinitions['Buyer'],
				$scope.filterService.filterDefinitions['Item Group'],
				$scope.filterService.filterDefinitions['ERP Order Policy'],
				$scope.filterService.filterDefinitions['Planner'],
				$scope.filterService.filterDefinitions['TaskStatus'],
				$scope.filterService.filterDefinitions['MaterialGroup'],
				$scope.filterService.filterDefinitions['MaterialType']
			]);
			$scope.filterService.defaultFilters = defaultFilters;
			$scope.filters = $scope.filterService.masterFilterList;
			$scope.rangeFilters = $scope.filterService.masterRangeFilterList;
			$scope.stringFilters = $scope.filterService.masterStringFilterList;
			$scope.filterService.setMasterSingleSelectFilterList([siteFilter]);
			$scope.singleSelectFilters = $scope.filterService.masterSingleSelectFilterList;
		}

		var pinnedColumns = [];

		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			reportUrl: pageUrl,
			noPaging: false,
			columns: columns,
			defaultSort: 'potentialToSell',
			defaultSortDirection: 'desc',
			pinnedColumns: pinnedColumns,
			extraParams: extraParams,
			rendererParams: rendererParams,
			pageSize: 50,
			searchType: 'item',
			hideSearch: false,
			excelRequest: true,
			defaultFilters: defaultFilters,
			crossSite: true,
			waitForFilters: true,
			setColumnDefaults: true,
			preConfigPromise: addAllFactoriesPromise(),
			controllerModifiesColumns: true,
			hasMandatoryFilters: true
		};

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.broadcastExcel = broadcastExcel;
		vm.reportName = 'Excess to sell';

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = vm.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}


		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', {doChooseColumns: true});
		}

		function getMeta() {
			return meta;
		}

		function initSites(extraParams) {
			var factoryIds = allFactoriesList.map(function (factory) {
				return factory.ndx;
			});
			extraParams[1] = {};
			extraParams[1].name = 'siteNdx';
			extraParams[1].value = factoryIds.toString();
			return extraParams;
		}

		function getData(params, extraParams) {
			extraParams = initSites(extraParams);
			meta.extraParams = extraParams;
			return tableService.getData(params, extraParams).then(function (response) {
				response.refreshMeta = true;
				enableFactories(response);
				headers(response);
				return response;
			});
		}

		function headers(response) {
			if (!response[0]) {
				return;
			}

			var sums = {};

			for (var id in rendererParams.siteIDs) {
				sums[id] = 0;
			}

			for (var id in rendererParams.siteIDs) {
				if (response[1][id]){
					sums[id] = response[1][id];
				}
			}
			for (var id in rendererParams.siteIDs) {
				var col = getColumn(id);
				if (col) {
					var newSum = convertToCurrency(sums[id], response[0].currency);
					if (newSum == ''){
						newSum = response[0].currency + '0';
					}
					col.display = rendererParams.siteNames[id] + ': ' + newSum ;
				}
			}
			var col = getColumn('potentialToSell');
			var total = convertToCurrency(response[1]['potentialToSell'],response[0].currency);
			if(total == ''){
				total = '$0';
			}
			col.display = 'Total: ' + total;
		}

		function convertToCurrency(val, currency) {
			var decimals = undefined;
			var keepAllDecimals = undefined;
			decimals = numberOfDecimals(val, decimals, keepAllDecimals);
			if (decimals == 1) decimals = 2;
			var formattedVal = val;
			if (val > 10 || val < -10) {
				decimals = 0;
			}
			if (val || val == 0) {
				var val = currencyFormatService.getWithParametersNegativeSign(val, decimals, currency);
				return val;
			}
			return val;
		}

		function numberOfDecimals(val, defaultDec, keepAllDecimals) {
			var decimals = defaultDec;
			if (!decimals && decimals !== 0)
				decimals = 2;
			if (keepAllDecimals) {
				var valTmp = '' + val;
				var valSplit = valTmp.split('.');
				if (valSplit && valSplit.length == 2) {
					valTmp = valSplit[1].replace(/0+$/, '');
					return valTmp.length;
				} else {
					return 0;
				}
			}
		}

		function getColumn(id) {
			var column;
			column = _.find(columns, {
				'id': id
			}) || _.find(pinnedColumns, {
				'id': id
			});;
			return column;
		}

		function initDefaultColumns() {
			columns = [{
				'id': 'itemCodeDisplay',
				'width': 180,
				'display': 'Item Code',
				'renderer': tableRenderService.itemCode
			},
			{
				'id': 'actionStatus',
				'width': 140,
				'display': 'Task Status',
				'renderer': tableRenderService.status
			},
			{
				'id': 'supplierName',
				'width': 140,
				'display': 'Supplier'
			},
			{
				'id': 'buyer',
				'display': 'Buyer',
				'width': 140,
				'renderer': tableRenderService.buyerCode
			},
			{
				'id': 'planner',
				'display': 'Planner',
				'width': 140
			},
			{
				'id': 'excessQuantity',
				'display': 'Excess On Hand Qty',
				'width': 140,
				'renderer': tableRenderService.integer
			},
			{
				'id': 'excessValue',
				'display': 'Excess On Hand Value',
				'width': 140,
				'renderer': tableRenderService.currency
			}, {
				id: 'materialType',
				display: 'Material Type',
				show: false,
				width: 80
			}, {
				id: 'materialGroup',
				display: 'Material Group',
				show: false,
				width: 80
			}, {
				id: 'itemGroupName',
				display: 'Item Group',
				show: false,
				width: 100
			}];
		}

		function addAllFactoriesPromise() {
			var promise = crossSiteService.getFactories();
			return promise.then(function (response) {
				if (!response.data) {
					allFactoriesList = [];
					return;
				}
				allFactoriesList = _.clone(response.data);
				var curFactory = globalConfig.factory;
				allFactoriesList.push({ ndx: curFactory.id, name: curFactory.alias || curFactory.name });
				allFactoriesList.forEach(function (factory) {
					columns.push({
						'id': 'potentialToSell_' + factory.ndx,
						'display': factory.name,
						'class': 'alignRight',
						'width': 150,
						'show': true,
						'renderer': tableRenderService.potentialToSell,
						'sortDefaultReverse': true,
						'disabled': true
					});
				});
				columns.push({
					'id': 'potentialToSell',
					'display': 'Total',
					'width': 150,
					'show': true,
					'renderer': tableRenderService.currency,
					'sortDefaultReverse': true,
					'disabled': true
				});
			}).catch(function (error) {
				$rootScope.$emit('toast', {
					'message': 'Unexpected server error',
					'success': false
				});
			});
		}

		function enableFactories(response) {
			if (!response[0] || !response[1]) {
				return;
			}
			var columnTotals = response[1];
			var columnsToEnable = Object.keys(columnTotals).filter(function (colId) {
				return colId.indexOf('potentialToSell') === 0 && columnTotals[colId] !== 0;
			});
			rendererParams.siteIDs = {};
			rendererParams.siteNames = {};
			var allColumns = columns.concat(pinnedColumns);
			allColumns.forEach(function (col) {
				if (col.id.indexOf('potentialToSell') === 0) {
					if (columnsToEnable.indexOf(col.id) > -1) {
						col.disabled = false;
						if (col.id !== 'potentialToSell') {
							var factoryId = +col.id.slice(16);
							var factory = allFactoriesList.find(function (f) {
								return f.ndx === factoryId;
							});
							rendererParams.siteIDs[col.id] = factoryId;
							rendererParams.siteNames[col.id] = factory.name;
						}
					} else {
						col.disabled = true;
					}
				}
			});
		}
	}
})();